import { fetcher } from "../api/fetcher";
import { roomState } from "../states/room";

export function adminAllOffMicro() {
  fetcher
    .post({
      path: "/active-room/all-micro-off",
      payload: {
        room_id: roomState.id,
      },
    })
    .catch(() => {
    });
}
